import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import "../intl.js";
import { init as t } from "../core/watchUtils.js";
import { aliasOf as s } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as i } from "../core/accessorSupport/decorators/cast.js";
import { property as n } from "../core/accessorSupport/decorators/property.js";
import { subclass as r } from "../core/accessorSupport/decorators/subclass.js";
import o from "./Widget.js";
import l from "./Feature/FeatureAttachments.js";
import d from "./Feature/FeatureContent.js";
import a from "./Feature/FeatureExpression.js";
import c from "./Feature/FeatureFields.js";
import u from "./Feature/FeatureMedia.js";
import p from "./Feature/FeatureViewModel.js";
import { FeatureContentMixin as m } from "./Feature/support/FeatureContentMixin.js";
import { Heading as h } from "./support/Heading.js";
import "./support/widgetUtils.js";
import { messageBundle as v } from "./support/decorators/messageBundle.js";
import "../core/Logger.js";
import { tsx as g } from "./support/jsxFactory.js";
import { substitute as f } from "../intl/substitute.js";
var y = {
  iconText: "esri-icon-font-fallback-text",
  iconLoading: "esri-icon-loading-indicator esri-rotating",
  esriTable: "esri-widget__table",
  esriWidget: "esri-widget",
  base: "esri-feature",
  container: "esri-feature__size-container",
  title: "esri-feature__title",
  main: "esri-feature__main-container",
  btn: "esri-feature__button",
  icon: "esri-feature__icon",
  content: "esri-feature__content",
  contentElement: "esri-feature__content-element",
  text: "esri-feature__text",
  lastEditedInfo: "esri-feature__last-edited-info",
  fields: "esri-feature__fields",
  fieldHeader: "esri-feature__field-header",
  fieldData: "esri-feature__field-data",
  fieldDataDate: "esri-feature__field-data--date",
  loadingSpinnerContainer: "esri-feature__loading-container",
  spinner: "esri-feature__loading-spinner"
},
    _ = {
  title: !0,
  content: !0,
  lastEditedInfo: !0
};

var w = /*#__PURE__*/function (_m) {
  _inherits(w, _m);

  var _super = _createSuper(w);

  function w(e, t) {
    var _this;

    _classCallCheck(this, w);

    _this = _super.call(this, e, t), _this._contentWidgets = [], _this.graphic = null, _this.defaultPopupTemplateEnabled = !1, _this.headingLevel = 2, _this.label = void 0, _this.messages = null, _this.messagesCommon = null, _this.messagesURIUtils = null, _this.spatialReference = null, _this.title = null, _this.visibleElements = _objectSpread({}, _), _this.map = null, _this.view = null, _this.viewModel = new p();
    return _this;
  }

  _createClass(w, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.own(t(this, "viewModel.contentViewModels", function () {
        return _this2._setupContentWidgets();
      }));
    }
  }, {
    key: "loadDependencies",
    value: function loadDependencies() {
      return import("@esri/calcite-components/dist/components/calcite-notice.js");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyContentWidgets();
    }
  }, {
    key: "castVisibleElements",
    value: function castVisibleElements(e) {
      return _objectSpread(_objectSpread({}, _), e);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this.viewModel.state,
          t = g("div", {
        class: y.container,
        key: "container"
      }, this.renderTitle(), "error" === e ? this.renderError() : "loading" === e ? this.renderLoading() : this.renderContentContainer());
      return g("div", {
        class: this.classes(y.base, y.esriWidget)
      }, t);
    }
  }, {
    key: "setActiveMedia",
    value: function setActiveMedia(e, t) {
      this.viewModel.setActiveMedia(e, t);
    }
  }, {
    key: "nextMedia",
    value: function nextMedia(e) {
      this.viewModel.nextMedia(e);
    }
  }, {
    key: "previousMedia",
    value: function previousMedia(e) {
      this.viewModel.previousMedia(e);
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var e = this.messagesCommon,
          t = this.messages,
          s = this.visibleElements;
      return g("calcite-notice", {
        active: !0,
        color: "red",
        icon: "exclamation-mark-circle",
        scale: "s"
      }, s.title ? g("div", {
        key: "error-title",
        slot: "title"
      }, e.errorMessage) : null, g("div", {
        key: "error-message",
        slot: "message"
      }, t.loadingError));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return g("div", {
        key: "loading-container",
        class: y.loadingSpinnerContainer
      }, g("span", {
        class: this.classes(y.iconLoading, y.spinner)
      }));
    }
  }, {
    key: "renderContentContainer",
    value: function renderContentContainer() {
      var e = this.visibleElements;
      return e.content ? g("div", {
        class: y.main
      }, [this.renderContent(), this.renderLastEditInfo()]) : null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var e = this.visibleElements,
          t = this.title;
      return e.title ? g(h, {
        level: this.headingLevel,
        class: y.title,
        innerHTML: t
      }) : null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var e = this.viewModel.content,
          t = "content";
      if (!e) return null;
      if (Array.isArray(e)) return e.length ? g("div", {
        key: "".concat(t, "-content-elements")
      }, e.map(this.renderContentElement, this)) : null;

      if ("string" == typeof e) {
        var _e = this._contentWidgets[0];
        return !_e || _e.destroyed ? null : g("div", {
          key: "".concat(t, "-content")
        }, _e.render());
      }

      return this.renderNodeContent(e);
    }
  }, {
    key: "renderContentElement",
    value: function renderContentElement(e, t) {
      var s = this.visibleElements;
      if ("boolean" != typeof s.content && !s.content[e.type]) return null;

      switch (e.type) {
        case "attachments":
          return this.renderAttachments(t);

        case "custom":
          return this.renderCustom(e, t);

        case "fields":
          return this.renderFields(t);

        case "media":
          return this.renderMedia(t);

        case "text":
          return this.renderText(e, t);

        case "expression":
          return this.renderExpression(t);

        default:
          return null;
      }
    }
  }, {
    key: "renderAttachments",
    value: function renderAttachments(e) {
      var t = this._contentWidgets[e];
      if (!t || t.destroyed) return null;
      var _t$viewModel = t.viewModel,
          s = _t$viewModel.state,
          i = _t$viewModel.attachmentInfos;
      return "loading" === s || i.length > 0 ? g("div", {
        key: this._buildKey("attachments-element", e),
        class: this.classes(y.contentElement)
      }, t.render()) : null;
    }
  }, {
    key: "renderExpression",
    value: function renderExpression(e) {
      var t = this._contentWidgets[e];
      return !t || t.destroyed ? null : g("div", {
        key: this._buildKey("expression-element", e),
        class: y.contentElement
      }, t.render());
    }
  }, {
    key: "renderCustom",
    value: function renderCustom(e, t) {
      var s = e.creator,
          i = this._contentWidgets[t];
      return !i || i.destroyed ? null : s ? g("div", {
        key: this._buildKey("custom-element", t),
        class: y.contentElement
      }, i.render()) : null;
    }
  }, {
    key: "renderFields",
    value: function renderFields(e) {
      var t = this._contentWidgets[e];
      return !t || t.destroyed ? null : g("div", {
        key: this._buildKey("fields-element", e),
        class: y.contentElement
      }, t.render());
    }
  }, {
    key: "renderMedia",
    value: function renderMedia(e) {
      var t = this._contentWidgets[e];
      return !t || t.destroyed ? null : g("div", {
        key: this._buildKey("media-element", e),
        class: y.contentElement
      }, t.render());
    }
  }, {
    key: "renderLastEditInfo",
    value: function renderLastEditInfo() {
      var e = this.visibleElements,
          t = this.messages,
          s = this.viewModel.lastEditInfo;
      if (!s || !e.lastEditedInfo) return null;
      var i = s.date,
          n = s.user,
          r = "edit" === s.type ? n ? t.lastEditedByUser : t.lastEdited : n ? t.lastCreatedByUser : t.lastCreated,
          o = f(r, {
        date: i,
        user: n
      });
      return g("div", {
        key: "edit-info-element",
        class: this.classes(y.lastEditedInfo, y.contentElement)
      }, o);
    }
  }, {
    key: "renderText",
    value: function renderText(e, t) {
      var s = e.text,
          i = this._contentWidgets[t];
      return !i || i.destroyed ? null : s ? g("div", {
        key: this._buildKey("text-element", t),
        class: this.classes(y.contentElement, y.text)
      }, i.render()) : null;
    }
  }, {
    key: "_buildKey",
    value: function _buildKey(e) {
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      return "".concat(e, "__").concat(this.get("viewModel.graphic.uid") || "0", "-").concat(t.join("-"));
    }
  }, {
    key: "_destroyContentWidget",
    value: function _destroyContentWidget(e) {
      e && (e.viewModel = null, !e.destroyed && e.destroy());
    }
  }, {
    key: "_destroyContentWidgets",
    value: function _destroyContentWidgets() {
      var _this3 = this;

      this._contentWidgets.forEach(function (e) {
        return _this3._destroyContentWidget(e);
      }), this._contentWidgets = [];
    }
  }, {
    key: "_setupContentWidgets",
    value: function _setupContentWidgets() {
      var _this4 = this;

      this._destroyContentWidgets();

      var e = this.headingLevel,
          t = this.visibleElements,
          s = this.get("viewModel.content"),
          i = this.viewModel.contentViewModels;
      if (Array.isArray(s)) s.forEach(function (s, n) {
        "attachments" === s.type && (_this4._contentWidgets[n] = new l({
          displayType: s.displayType,
          headingLevel: t.title ? e + 1 : e,
          viewModel: i[n]
        })), "fields" === s.type && (_this4._contentWidgets[n] = new c({
          viewModel: i[n]
        })), "media" === s.type && (_this4._contentWidgets[n] = new u({
          viewModel: i[n]
        })), "text" === s.type && (_this4._contentWidgets[n] = new d({
          viewModel: i[n]
        })), "custom" === s.type && (_this4._contentWidgets[n] = new d({
          viewModel: i[n]
        })), "expression" === s.type && (_this4._contentWidgets[n] = new a({
          viewModel: i[n]
        }));
      }, this);else {
        var _e2 = i[0];
        _e2 && !_e2.destroyed && (this._contentWidgets[0] = new d({
          viewModel: _e2
        }));
      }
      this.scheduleRender();
    }
  }]);

  return w;
}(m(o));

e([s("viewModel.graphic")], w.prototype, "graphic", void 0), e([s("viewModel.defaultPopupTemplateEnabled")], w.prototype, "defaultPopupTemplateEnabled", void 0), e([n()], w.prototype, "headingLevel", void 0), e([n({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], w.prototype, "label", void 0), e([n(), v("esri/widgets/Feature/t9n/Feature")], w.prototype, "messages", void 0), e([n(), v("esri/t9n/common")], w.prototype, "messagesCommon", void 0), e([n(), v("esri/widgets/support/t9n/uriUtils")], w.prototype, "messagesURIUtils", void 0), e([s("viewModel.spatialReference")], w.prototype, "spatialReference", void 0), e([s("viewModel.title")], w.prototype, "title", void 0), e([n()], w.prototype, "visibleElements", void 0), e([i("visibleElements")], w.prototype, "castVisibleElements", null), e([s("viewModel.map")], w.prototype, "map", void 0), e([s("viewModel.view")], w.prototype, "view", void 0), e([n({
  type: p
})], w.prototype, "viewModel", void 0), w = e([r("esri.widgets.Feature")], w);
var M = w;
export { M as default };